import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {NotifierService} from "angular-notifier";
import {UserService} from "../../../service/user.service";
import {BsModalService} from "ngx-bootstrap";
import {ImageCroppedEvent} from "ngx-image-cropper";

@Component({
  selector: 'app-university',
  templateUrl: './university.component.html',
  styleUrls: ['./university.component.scss']
})
export class UniversityComponent implements OnInit {

  desti: any;
  form: any;
  @ViewChild("errorModal", {static: true}) errorModal;
  @ViewChild("addModal", {static: true}) addModal;
  up: boolean;
  upId: any;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  showCropper = false;
  imageCropper: any;
  dest: any;
  unis: any;
  ty: any;
  totalRec: any;
  page: any;
  searchform: any;
  constructor(private formBuilder: FormBuilder, private route: Router, private notifier: NotifierService,
              private userService: UserService, private modalService: BsModalService) {

    this.form = this.formBuilder.group({
      // desc: ["", [Validators.required]],
      name: ["", [Validators.required]],
      dest: ["", [Validators.required]],
    });
    this.searchform = this.formBuilder.group({
      search: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    this.getAllDestination();
    this.getAllUni();
  }

  getAllDestination() {

    this.userService.getallDestinations().subscribe(
      res => {
        if (res.responseCode === 200) {
          this.dest = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  getAllUni() {
    this.unis =null;
    this.userService.getAllUni().subscribe(
      res => {
        if (res.responseCode === 200) {
          this.unis = res.data;
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  search(pageIndex) {

    let size = 10;
    let page = pageIndex - 1;
    this.userService.searchUni(this.searchform.controls.search.value,size,page).subscribe(
      res=>{
        if (res.responseCode === 200) {
          this.unis =res['data']['content'];
          this.page = res['data']['number'];
          this.totalRec = res['data']['totalElements'];
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  new() {
    let req = {
      // description: this.form.controls.desc.value,
      name: this.form.controls.name.value,
    }
    this.userService.createUni(req,this.form.controls.dest.value,).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.upload(res.data)
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.getAllUni();
          this.form.reset();
          this.imageChangedEvent = '';
          this.croppedImage = '';
          this.showCropper = false;
          this.imageCropper = '';
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  window(up,obj) {
    this.ty ='New'
    this.up=false;
    this.addModal.show();
    if(up=='up'){
      this.ty ='Update'
      this.up=true;
      this.upId=obj.id;
      this.form.controls['name'].setValue(obj.name);
      this.form.controls['dest'].setValue(obj.studyDestination.id);
    }
  }

  update() {
    let req = {
      id:this.upId,
      name: this.form.controls.name.value,
    }
    this.userService.createUni(req,this.form.controls.dest.value,).subscribe(
      res => {
        if (res.responseCode === 200) {
          this.upload(res.data)
          this.notifier.notify('success', res.responseDesc);
          this.addModal.hide()
          this.form.reset();
          this.imageChangedEvent = '';
          this.croppedImage = '';
          this.showCropper = false;
          this.imageCropper = '';
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.file;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  rotateLeft() {
    this.imageCropper.rotateLeft();
  }

  rotateRight() {
    this.imageCropper.rotateRight();
  }

  flipHorizontal() {
    this.imageCropper.flipHorizontal();
  }

  flipVertical() {
    this.imageCropper.flipVertical();
  }

  upload(id) {
    this.userService.uniImgUpload( this.croppedImage,id).subscribe(
      data => {
        if(data.responseCode==200){
          this.getAllUni();
          this.notifier.notify('success', data.responseDesc);
        }else {
          this.notifier.notify('danger', 'Somthing went wrong faild to upload image.');
        }
      });
  }

  getAlldest(){
    this.userService.getallDestinations().subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.dest = res.data
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }

  delete(id) {
    this.userService.deleteUni(id).subscribe(
      res=>{
        if (res.responseCode == 200) {
          this.notifier.notify('success', res.responseDesc);
          this.getAllUni();
        } else {
          this.notifier.notify('danger', res.responseDesc);
        }
      }
    )
  }
}
